import { render, staticRenderFns } from "./SocialStreamCatalogs.vue?vue&type=template&id=78068420&lang=html"
import script from "./SocialStreamCatalogs.vue?vue&type=script&lang=ts"
export * from "./SocialStreamCatalogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports